const config = {
    BACK_BASE_URL: "https://localhost:8444/",
    BACK_URL: "https://localhost:8444/api/",
    KIBANA_URL: "https://pemmdb-dev.rtei-europe.com/kibana"
}
export default config;
